import React from 'react';
import { ArrowRight, CheckCircle2, ShieldCheck, Sparkles, Wallet } from 'lucide-react';

export function AmbassadorsHeroVisual({ copy }) {
  const v = copy.heroVisual;
  const steps = copy.howSteps.slice(0, 4);

  return (
    <div className="relative min-w-0">
      <div
        className="pointer-events-none absolute -inset-4 rounded-[2rem] bg-gradient-to-br from-emerald-500/15 via-amber-500/10 to-indigo-500/10 blur-2xl opacity-80"
        aria-hidden
      />
      <div className="relative rounded-[1.75rem] border border-white/[0.12] bg-slate-950/55 backdrop-blur-xl p-6 sm:p-8 shadow-[0_32px_100px_-40px_rgba(16,185,129,0.25)]">
        <div className="flex items-center justify-between gap-3 mb-6">
          <div className="inline-flex items-center gap-2 rounded-full border border-emerald-500/25 bg-emerald-500/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-emerald-200/90">
            <Sparkles className="w-3.5 h-3.5 text-emerald-400" aria-hidden />
            {v.programLabel}
          </div>
          <ShieldCheck className="w-5 h-5 text-emerald-400/80 shrink-0" aria-hidden />
        </div>

        <p className="text-[11px] font-semibold uppercase tracking-wider text-white/40 mb-3">{v.stepLabel}</p>
        <ol className="space-y-3 mb-6">
          {steps.map((step, i) => (
            <li key={step.title} className="flex gap-3 items-start min-w-0">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-white/10 bg-white/[0.04] text-xs font-bold text-amber-300">
                {i + 1}
              </span>
              <div className="min-w-0 pt-0.5">
                <p className="text-sm font-semibold text-white/85 leading-snug">{step.title}</p>
                <p className="text-xs text-white/45 font-light leading-relaxed mt-0.5">{step.desc}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="grid sm:grid-cols-2 gap-3">
          <div className="rounded-xl border border-white/[0.08] bg-white/[0.03] px-4 py-3.5">
            <div className="flex items-center gap-2 mb-1.5">
              <Wallet className="w-4 h-4 text-amber-400" aria-hidden />
              <p className="text-[11px] font-semibold uppercase tracking-wide text-white/45">{v.payoutLabel}</p>
            </div>
            <p className="text-sm font-semibold text-white/80 leading-snug">{v.payoutValue}</p>
          </div>
          <div className="rounded-xl border border-emerald-500/20 bg-emerald-500/[0.06] px-4 py-3.5">
            <div className="flex items-center gap-2 mb-1.5">
              <CheckCircle2 className="w-4 h-4 text-emerald-400" aria-hidden />
              <p className="text-[11px] font-semibold uppercase tracking-wide text-emerald-200/70">{v.trustLabel}</p>
            </div>
            <p className="text-xs text-white/55 font-light leading-relaxed">{v.trustDesc}</p>
          </div>
        </div>

        <div className="mt-5 flex items-center gap-2 text-xs text-white/40 font-light">
          <ArrowRight className="w-3.5 h-3.5 text-amber-400/80 shrink-0" aria-hidden />
          <span>{copy.heroHighlight}</span>
        </div>
      </div>
    </div>
  );
}
